const state = () => ({
  // cardBackground: "#4caf50",
  // sidebarType: 2,
  tabIndex: 0,
})

// getters
const getters = {
  // getCardBackground(state) {
  //   return state.cardBackground
  // },
}

// actions
const actions = {}

// mutations
const mutations = {
  setTabIndex(state, payload) {
    state.tabIndex = payload
  }
  // setBackground(state, color) {
  //   state.cardBackground = color
  // },
  // setTopBarMenuName(state,menuname){
  //   state.topBarMenuName = menuname;
  // },

  // setSidebarType(state, sidebarType) {
  //   state.sidebarType = sidebarType
  // },
  // setExincludeList(state, exincludeList) {
  //   state.exincludeList = exincludeList
  // },
}

export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/design.js